// extracted by mini-css-extract-plugin
module.exports = {"spin":"spin--13Xpw"};